import { usePipelineContext } from '@/context/pipelineContext';
import { getPipelineIcon } from '@/utils/constants';
import { Stack, Typography, useTheme } from '@mui/material';
import React from 'react';

const DataGridPipeline = ({ pipeline, hideIcon = false }) => {
	const theme = useTheme();
	const data = usePipelineContext(pipeline);

	const pipelineIcon = getPipelineIcon(
		pipeline,
		'16px',
		theme.palette.mode === 'dark' ? { bgColor: 'transparent' } : undefined,
	);

	return (
		<Stack direction='row' alignItems='center' spacing={1} sx={{ height: '100%' }}>
			{!hideIcon && pipelineIcon}
			<Typography variant='body2'>{data?.pipeline?.label ?? ''}</Typography>
		</Stack>
	);
};
DataGridPipeline.displayName = 'DataGridPipeline';
export default DataGridPipeline;
